import { createContext } from 'react';

import type { ApiBillingSummary } from '@/shared/api';
import type { PlanDefinition, PlanFeature, PlanTier } from '@/shared/config/plans';

export type PlanContextValue = {
  tier: PlanTier;
  plan: PlanDefinition;
  /** The signed-in master's billing summary; null until loaded and for everyone else. */
  summary: ApiBillingSummary | null;
  /** Whether the current tier unlocks a gated feature. */
  can: (feature: PlanFeature) => boolean;
};

export const PlanContext = createContext<PlanContextValue | undefined>(undefined);
